module.exports = __webpack_public_path__ + "img/result_obj03.84a310da.png";